import * as deleteHelpers from './delete/DeleteHelpers';
import * as disableHelpers from './disable/DisableHelpers';
import * as productsHelpers from './products/ProductsHelpers';
import * as selectMultipleHelpers from './select-multiple/SelectMultipleHelpers';
import * as updateHelpers from './update/UpdateHelpers';
import * as settingsHelpers from './settings/SettingsHelpers';
import * as clearHelpers from './clear/ClearHelpers';
import * as changeHelpers from './change/ChangeHelpers';
import * as undoDeleteHelpers from './undo-delete/UndoDeleteHelpers';
import * as receiveProductTemplates from './template/SettingsTemplateHelpers';

const helpers = {
  ...deleteHelpers,
  ...disableHelpers,
  ...productsHelpers,
  ...selectMultipleHelpers,
  ...updateHelpers,
  ...settingsHelpers,
  ...clearHelpers,
  ...undoDeleteHelpers,
  ...receiveProductTemplates,
  ...changeHelpers,
};

export default helpers;
